import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

//Promocoes\
const Promocoes = () => import("@/views/promocoes/Promocoes");
const InserirPromocao = () => import("@/views/promocoes/InserirPromocao");
const EditarImagem = () => import("@/views/promocoes/EditarImagem");
const EditarImagemJornalzinho = () => import("@/views/promocoes/EditarImagemJornalzinho");
const EditarPromocao = () => import("@/views/promocoes/EditarPromocao");
const CadastrarCampanha = () =>
  import("@/views/pages/CadastrarCampanha");
const ReenviarCampanha = () => import("@/views/pages/ReenviarCampanha");
const Destaques = () => import("@/views/promocoes/Destaques");

//Análise
const Analise = () => import("@/views/pages/Analise");

//Análises - Produtos
const AnalisesProdutos = () => import("@/views/analises/produtos/Analises");
const Setores = () => import("@/views/analises/produtos/detalhamento/Setores");
const Marcas = () => import("@/views/analises/produtos/detalhamento/Marcas");
const Grupos = () => import("@/views/analises/produtos/detalhamento/Grupos");
const Produtos = () => import("@/views/analises/produtos/detalhamento/Produtos");

// Análises - Clientes
const AnalisesClientes = () => import("@/views/analises/clientes/Analises");
const AnalisePeriodo = () => import("@/views/analises/clientes/detalhamento/AnalisePeriodo");
const AnaliseProduto = () => import("@/views/analises/clientes/detalhamento/AnaliseProduto");

//Pacotes
const Pacotes = () => import("@/views/pacotes/Pacotes");
const AdquirirPacotes = () => import("@/views/pacotes/AdquirirPacotes");
const Pushs = () => import("@/views/pushs/Pushs");

//Interesses
const Interesses = () => import("@/views/interesses/Interesses");
const EditarImagemInteresses = () => import("@/views/interesses/EditarImagem");

//Sorteios
const Sorteios = () => import("@/views/sorteios/Sorteios");
const InserirSorteio = () => import("@/views/sorteios/InserirSorteio");
const EditarSorteio = () => import("@/views/sorteios/EditarSorteio");
const EditarImagemSorteio = () => import("@/views/sorteios/EditarImagem");

const Opcoes = () => import("@/views/opcoes/Opcoes");
const Contatos = () => import("@/views/contatos/Contatos");
const InserirContato = () => import("@/views/contatos/InserirContato");

// Views - Pages
const Login = () => import("@/views/pages/Login");
const Verificacao = () => import("@/views/pages/Verificacao");

// Clientes
const Clientes = () => import("@/views/clientes/Clientes");
const Cliente = () => import("@/views/clientes/Cliente");

// Cupons
const Cupons = () => import("@/views/cupons/Cupons");
const CadastrarCupon = () => import("@/views/cupons/CadastrarCupom");

// Banner
const Banner = () => import("@/views/banner/Banner");
const AdicionarBanner = () => import("@/views/banner/Adicionar");

// Cardapio
const Cardapio = () => import("@/views/cardapio/Cardapio");

Vue.use(Router);

let router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: "/",
      redirect: "/relatorios",
      name: "Início",
      component: DefaultContainer,
      children: [{
          path: "relatorios",
          name: "Relatórios",
          component: Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "banner",
          name: "Banner",
          redirect: "/banner",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true
          },
          children: [{
            path: "",
            component: Banner,
          }, {
            path: "adicionar",
            name: "Adicionar",
            component: AdicionarBanner
          }, {
            path: "editar",
            name: "Editar",
            component: AdicionarBanner
          }]
        },
        {
          path: "analise",
          name: "Análise de Período",
          component: Analise,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/cardapio",
          name: "Cardapio",
          component: Cardapio,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "analises",
          name: "Análises",
          redirect: "/analises/produtos",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
            path: "produtos",
            name: "Produtos",
            redirect: "/analises/produtos",
            meta: {
              requiresAuth: true
            },
            component: {
              render(c) {
                return c("router-view");
              }
            },
            children: [{
                path: "",
                component: AnalisesProdutos,
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "setor",
                name: "Setores",
                component: Setores,
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "marca",
                name: "Marcas",
                component: Marcas,
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "grupo",
                name: "Grupos",
                component: Grupos,
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: "produto",
                name: "Produto",
                component: Produtos,
                meta: {
                  requiresAuth: true
                }
              },
            ],
          }, {
            path: "clientes",
            name: "Clientes",
            redirect: "/analises/clientes",
            meta: {
              requiresAuth: true
            },
            component: {
              render(c) {
                return c("router-view");
              }
            },
            children: [{
                path: "",
                component: AnalisesClientes
              },
              {
                path: "periodo",
                name: "Periodo",
                redirect: "/clientes",
                component: {
                  render(c) {
                    return c("router-view");
                  },
                },
                children: [{
                    path: "",
                    component: AnalisePeriodo,
                  },
                  {
                    path: "comparacao",
                    name: "Produto",
                    component: AnaliseProduto
                  },
                ]
              },
            ]
          }],
        },
        {
          path: "contatos",
          name: "Contatos",
          redirect: "/contatos",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Contatos,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "inserir-contato",
              name: "Inserir Contato",
              component: InserirContato,
              meta: {
                requiresAuth: true
              }
            },
          ],
        },
        {
          path: "cupons",
          name: "Cupons",
          redirect: "/cupons",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Cupons,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "/cadastrar-cupom",
              name: "Cadastrar Cupom",
              component: CadastrarCupon,
              meta: {
                requiresAuth: true
              }
            },
          ],
        },
        {
          path: "opcoes",
          name: "Opções",
          redirect: "/opcoes",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
            path: "",
            component: Opcoes,
            meta: {
              requiresAuth: true
            }
          }, ],
        },
        {
          path: "clientes",
          name: "Clientes",
          component: Clientes,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "cliente/:id",
          name: "Cliente",
          component: Cliente,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "campanhas",
          name: "Pushs",
          redirect: "/campanhas",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
            path: "",
            component: Pushs,
            meta: {
              requiresAuth: true
            }
          }]
        },
        {
          path: "reenviar-campanha",
          name: "Reenviar Campanha",
          component: ReenviarCampanha,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "interesses",
          name: "Interesses",
          redirect: "/interesses",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Interesses,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: EditarImagemInteresses,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: "sorteios",
          name: "Sorteios",
          redirect: "/sorteios",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Sorteios,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar-sorteio/:id",
              name: "Editar Sorteio",
              component: EditarSorteio,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar-imagem",
              name: "Editar Imagem - Sorteio",
              component: EditarImagemSorteio,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "inserir-sorteio",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true
              },
              children: [{
                path: "",
                name: "Inserir Sorteio",
                component: InserirSorteio,
                meta: {
                  requiresAuth: true
                }
              }, ]
            }
          ]
        },
        {
          path: "cadastrar-campanha",
          name: "Cadastrar Campanha",
          component: CadastrarCampanha,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "promocoes",
          name: "Promocoes",
          redirect: "/promocoes",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Promocoes,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "destaques",
              name: "Destaques",
              component: Destaques,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar-imagem",
              name: "Editar Imagem - Promoção",
              component: EditarImagem,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar-imagem-jornalzinho",
              name: "Editar Imagem - Jornalzinho",
              component: EditarImagemJornalzinho,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "editar-promocao/:id",
              name: "Editar Promoção",
              component: EditarPromocao,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: "inserir-promocao",
              name: "Inserir Promoção",
              meta: {
                requiresAuth: true
              },
              component: InserirPromocao
            },
          ]
        },
        {
          path: "pacotes",
          name: "Pacotes",
          redirect: "/pacotes",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
              path: "",
              component: Pacotes,
              props: (route) => ({
                query: route.query.status
              }),
              meta: {
                requiresAuth: true
              },
            },
            {
              path: "adquirir-pacotes",
              name: "Adquirir Pacotes",
              component: AdquirirPacotes,
              meta: {
                requiresAuth: true
              },
            },
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: "/verificacao",
      name: "Verificacao",
      component: Verificacao
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") == null) {
      next({
        path: "/login",
        params: {
          nextUrl: to.fullPath
        }
      });
    } else {
      if (to.matched.some(record => record.meta.is_admin)) {
        next({
          name: "Relatórios"
        });
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem("jwt") == null) {
      next();
    } else {
      next({
        name: "Relatórios"
      });
    }
  } else {
    next();
  }
});

export default router;
